<ngx-spinner bdColor="rgba(255,255,255,0.9)" size="medium" color="#059669">
  <div class="flex flex-col items-center gap-3">
    <img
      src="assets/Green_Energy_Mobility_Logo-removebg-preview.png"
      alt="Logo"
      class="h-14 w-14 object-contain"
    />
    <div
      class="h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-emerald-600"
      role="status"
      aria-label="Đang tải"
    ></div>
    <p class="text-sm text-slate-600">Đang tải...</p>
  </div>
</ngx-spinner>

<div>
  <router-outlet></router-outlet>
</div>
